import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { defaulUrl, Loading } from "../components/const";
import Swal from "sweetalert2";



const GetPwd = () => {
    const [loader, setIsLoading] = useState(false)
    const navigate = useNavigate();
    const handleSubmite = (e) => {
        e.preventDefault();
        let formData = new FormData(e.target);
        let status = 0
        setIsLoading(true)
        fetch(`${defaulUrl}reset-pwd`, {
            method: "POST",
            body: formData
        }).then((response) => {
            status = response.status;
            return response.json();
        }).then(data => {
            setIsLoading(false);
            if (status == 200) {
                Swal.fire({
                    title: "Recuperation de mot de passe",
                    html: ` <div class="text-secondary">Votre mot de passe a été réinitialisé et le nouveau est <span class="fw-bold text-danger">${data?.message}</span></div>
                    <div class="text-warning small">Il est recommandé de changer ce mot de passe dès après la connexion.</div>
                    `,
                    icon: 'success'
                }).then(() => navigate('/'))
            } else {

                Swal.fire({
                    title: "Operation impossible",
                    text: data?.errors,
                    icon: 'error'
                })

            }
        });

    }

    return (
        <div className="Login bg-login">
            <div className="wrapper">
                <div className="section-authentication-signin d-flex align-items-center justify-content-center my-5 my-lg-0">
                    <div className="container-fluid">
                        <div className="row row-cols-1 row-cols-lg-2 row-cols-xl-3">
                            <div className="col mx-auto">
                                <div className="mb-4 text-center">
                                    <img src="../assets/images/logo-img.png" width="180" alt="" />
                                </div>
                                <div className="card">
                                    <div className="card-body">
                                        <div className="border p-4 rounded">
                                            <div className="text-center">
                                                <h3 className="">Récuperer mon mot de passe</h3>
                                            </div>

                                            <div className="login-separater text-center mb-4"> <span>VOTRE EMAIL</span>
                                                <hr />
                                            </div>
                                            <div className="form-body">
                                                <form className="row g-3" onSubmit={handleSubmite}>
                                                    <div className="col-12">
                                                        <label htmlFor="email" className="form-label"> Adresse Email</label>
                                                        <input type="email" className="form-control" name="email" id="email" placeholder="adresse email " required />
                                                    </div>
                                                    <div className="col-12">
                                                        <label htmlFor="email" className="form-label"> Telephone</label>
                                                        <input type="number" className="form-control" id="phone" name="phone" placeholder="votre contact " required />
                                                        <small className="text-warning">Veuillez fournir voutre contact lié a votre compte</small>
                                                    </div>

                                                    <div className="col-md-12 text-end">	<NavLink to='/login'>Retour à la page de connexion?</NavLink>
                                                    </div>
                                                    {loader && <Loading />}
                                                    <div className="col-12">
                                                        <div className="d-grid">
                                                            <button type="submit" className="btn btn-primary"><i className="bx bxs-send"></i>Envoyer</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default GetPwd;